import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
    getFollowCreativeSetLoaded,
    getError,
    getIsFollower,
    getUserEmail,
    getUserName
} from './follow-creativeset.selectors';
import {
    followActions,
    loadActions,
    showcaseFollowActions,
    showcaseLoadActions,
    showcaseUnfollowActions,
    unfollowActions
} from './follow-creativeset.actions';

@Injectable({
    providedIn: 'root'
})
export class FollowCreativeSetService {
    private store = inject(Store);

    loaded$ = this.store.select(getFollowCreativeSetLoaded);
    error$ = this.store.select(getError);
    isFollower$ = this.store.select(getIsFollower);

    userEmail$ = this.store.select(getUserEmail);
    userName$ = this.store.select(getUserName);

    loadIsFollower(creativeSetId: number): void {
        this.store.dispatch(loadActions.load({ creativeSetId }));
    }

    followCreativeSet(creativeSetId: number): void {
        this.store.dispatch(followActions.follow({ creativeSetId }));
    }

    unfollowCreativeSet(creativeSetId: number): void {
        this.store.dispatch(unfollowActions.unfollow({ creativeSetId }));
    }

    showcaseInitState(creativeSetId: number): void {
        this.store.dispatch(showcaseLoadActions.init({ creativeSetId }));
    }

    showcaseLoadIsFollower(creativeSetId: number, userEmail: string): void {
        this.store.dispatch(showcaseLoadActions.load({ creativeSetId, userEmail }));
    }

    showcaseFollowCreativeSet(creativeSetId: number, userEmail: string, userName: string): void {
        this.store.dispatch(showcaseFollowActions.follow({ creativeSetId, userEmail, userName }));
    }

    showcaseUnfollowCreativeSet(creativeSetId: number, userEmail: string): void {
        this.store.dispatch(showcaseUnfollowActions.unfollow({ creativeSetId, userEmail }));
    }
}
